import React, { useState, useEffect, useMemo } from 'react';
import { Auth } from 'aws-amplify';
import { ContentTitle } from '../ui/styled';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Episode from '../Episode/Episode';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import moment from 'moment';
import { dateFormat, ADD_PARTICIPANT_FORM_URL, PARTICIPANT_DELETE_URL } from '../../constants';
import TabPanel, { a11yProps } from '../common/Tabs/TabPanel';
import BackIcon from '../common/Back/BackIcon';
import PageHeading from '../common/Heading/PageHeading';
import ParticipantComment from './ParticipantComment';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import { getAddParticipantFormSlice } from '../../redux/participant/AddParticipant/addParticipantSliceForm';
import ParticipantDialog from '../Participant/ParticipantDialog';
import { getContactByUser } from '../Contact/services/contactsApi';
import { deleteStopApi } from '../../services/StopApi/StopApi';

const ParticipantDetails = () => {
  //console.log('### load participant details')
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  //const [authToken, setAuthToken] = useState(null);
  const [open, setOpen] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [value, setValue] = useState(0);
  const [singleParticipant, setSingleParticipant] = useState([]);
  const [episodeCount, setEpisodeCount] = useState(0);
  const participantInfo = useSelector(
    (state) => state?.participants?.participantsDetail
  );
  const participantsReferenceInfo = useSelector(
    (state) => state?.participantsReferenceData
  );
  //console.log('### participantsReferenceInfo')
  //console.log(participantsReferenceInfo)

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      try {
        const loggedInContact = await getContactByUser(user);
        user.contact = loggedInContact;
      } catch (error) {
        console.log('Error fetching contact');
      }
      return user;
    } catch (error) {
      console.log('Not signed in');
      return null;
    }
  };

const fetchData = () => {
    //console.log('### participantInfo')
    //console.log(participantInfo)
    setSingleParticipant(
      participantInfo.map((item, index) => ({
        id: item.id,
        key: item.key,
        lastName: item.lastName,
        firstName: item.firstName,
        middleName: item.middleName,
        suffix: item.suffix,
        gender: item.gender.value || item.gender,
        ethnicityOrRace: item.ethnicityOrRace?.value,
        veteran: item.veteran,
        deployedCombatDuty: item.deployedCombatDuty,
        diagnosedPostTraumaticStressDisorder:
          item.diagnosedPostTraumaticStressDisorder,
        arsonist: item.arsonist,
        ssn: item.SSN ? item.SSN : '-',
        dateOfBirth: item.dateOfBirth,
        registration290: item.registration290,
      }))
    );
  };

    useEffect(() => {
      const initUser = async () => {
        const userData = await getUser();
        setUser(userData);
      };

      if (!user) {
        initUser();
      }
    }, [user]);

  useEffect(() => {
    if (participantInfo) {
      fetchData();
    }
  }, [participantInfo]);

  

  const updateParticipantDialog = (params) => {
    getUser().then((userData) => {
      const url = `${ADD_PARTICIPANT_FORM_URL}/participants/${params.row.id}`;
      //console.log('### authToken');
      //console.log(authToken);
      const authorization = `${userData.signInUserSession.accessToken.jwtToken}`;
      //console.log('### authorization')
      //console.log(authorization)
      setOpenBackdrop(true);
      setTimeout(() => {
        setOpenBackdrop(false);
      }, 700);
      dispatch(getAddParticipantFormSlice({ url, authorization }));
      setOpen(true);
    });
  };

  const handleDeleteParticipant = async () => {
    if (!window.confirm('Are you sure you want to delete this participant?')) {
      return;
    }

    const url = `${PARTICIPANT_DELETE_URL}/${singleParticipant[0]?.id}`;
    const payload = {};
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;

    deleteStopApi({ url, payload, authorization })
      .then((response) => {
        console.log('### delete response');
        console.log(response);
        // Navigate back to participants list
        navigate('/participants');
      })
      .catch((error) => {
        console.log('### delete error');
        console.log(error);
        alert('Failed to delete participant: ' + (error?.response?.data || error?.message || 'Unknown error'));
      });
  };

  const columnsData = useMemo(
    () => [
      {
        field: 'actions',
        headerName: 'Actions',
        cellClassName: 'participant-header',
        //type: 'actions',
        renderCell: (params) => {
          return (
            <IconButton onClick={() => updateParticipantDialog(params)}>
              <EditIcon />
            </IconButton>
          );
        },
      },
      {
        field: 'key',
        headerName: 'Participant Key',
        minWidth: 120,
        sortable: false,
        cellClassName: 'participant-header'
      },
      {
        field: 'firstName',
        headerName: 'First Name',
        minWidth: 100,
        sortable: false,
        cellClassName: 'participant-header'
      },
      {
        field: 'middleName',
        headerName: 'Middle Name',
        minWidth: 112,
        sortable: false,
        cellClassName: 'participant-header'
      },
      {
        field: 'lastName',
        headerName: 'Last Name',
        minWidth: 100,
        sortable: false,
        cellClassName: 'participant-header'
      },
      {
        field: 'suffix',
        headerName: 'Suffix',
        flex: 1,
        sortable: false,
        cellClassName: 'participant-header'
      },
      {
        field: 'ssn',
        headerName: 'SSN',
        flex: 1,
        sortable: false,
        cellClassName: 'participant-header'
      },
      {
        field: 'dateOfBirth',
        headerName: 'DOB',
        minWidth: 80,
        sortable: false,
        type: 'date',
        renderCell: (params) => {
          const today = new Date();
          const age = today.getFullYear() - params.value?.split('-')[0];
          return (
            <Box style={{ display: 'flex', flexDirection: 'column' }}>
              <Typography>{moment(params.value).format(dateFormat)}</Typography>
              <Typography>Age: {age}yrs</Typography>
            </Box>
          );
        },
        cellClassName: 'participant-header'
      },
      {
        field: 'gender',
        headerName: 'Gender',
        flex: 1,
        sortable: false,
        //type: 'singleSelect',
        //valueOptions: participantsReferenceInfo?.genders.map(
        //  (item) => item.value
        //),
        cellClassName: 'participant-header'
      },
      {
        field: 'ethnicityOrRace',
        headerName: 'Ethnicity Or Race',
        flex: 1,
        sortable: false,
        type: 'singleSelect',
        valueOptions: participantsReferenceInfo?.ethnicities.map(
          (item) => item.value
        ),
        cellClassName: 'participant-header'
      },
      {
        field: 'veteran',
        headerName: 'Veteran',
        flex: 1,
        sortable: false,
        type: 'boolean',
        cellClassName: 'participant-header'
      },
      {
        field: 'deployedCombatDuty',
        headerName: 'Deployed Combat Duty',
        flex: 1,
        sortable: false,
        type: 'boolean',
        cellClassName: 'participant-header'
      },
      {
        field: 'diagnosedPostTraumaticStressDisorder',
        headerName: 'Diagnosed Post Traumatic Stress Disorder',
        flex: 1,
        minWidth: 120,
        sortable: false,
        type: 'boolean',
        cellClassName: 'participant-header'
      },
      {
        field: 'registration290',
        headerName: '290 Reg',
        flex: 1,
        sortable: false,
        type: 'boolean',
        cellClassName: 'participant-header'
      },
      {
        field: 'arsonist',
        headerName: 'Arsonist',
        flex: 1,
        sortable: false,
        type: 'boolean',
        cellClassName: 'participant-header'
      },
    ],
    [
      participantsReferenceInfo?.ethnicities,
      participantsReferenceInfo?.genders
    ]
  );

  return (
    <>
      <ContentTitle container>
        <BackIcon />
        <PageHeading title='Participant' />
      </ContentTitle>
      <div style={{ height: 145, width: '100%' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div style={{ flexGrow: 1 }}>
            <DataGrid
              autoHeight
              hideFooter
              getRowHeight={() => 'auto'}
              columns={columnsData}
              rows={singleParticipant}
              disableColumnFilter
              disableColumnMenu
            />
          </div>
        </div>
      </div>
      {user?.contact?.authLock === true && episodeCount === 0 && (
        <Box pt={2}>
          <Button
            variant="contained"
            color="error"
            onClick={handleDeleteParticipant}
          >
            Delete Participant
          </Button>
        </Box>
      )}
      <Box pt={2} sx={{ width: '100%' }}>
        <Box
          sx={{
            borderBottom: 2,
            borderColor: '#747070',
            padding: '0px 0px 5px 0px',
          }}
        >
          <Tabs
            sx={{
              '& .MuiTabs-flexContainer': {
                flexWrap: 'wrap',
              },
            }}
            value={value}
            onChange={handleTabChange}
            aria-label='basic tabs example'
          >
            <Tab label='Episodes' {...a11yProps(0)} />
            <Tab label='Participant Comment' {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Episode
            singleParticipantId={singleParticipant[0]?.id}
            onEpisodeCountChange={setEpisodeCount}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ParticipantComment />
        </TabPanel>
      </Box>
      <ParticipantDialog
          open={open}
          setOpen={setOpen}
          openBackdrop={openBackdrop}
          fetchData={fetchData}
          authToken={user?.signInUserSession.accessToken.jwtToken}
      />
    </>
  );
};

export default ParticipantDetails;
